import React, {useState, useEffect, useContext, Suspense, lazy} from "react";
import "./Project.scss";
import Button from "../../components/button/Button";
import {openSource, socialMediaLinks} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import Loading from "../../containers/loading/Loading";




const dummyRepoData = [
  {
    node: {
      id: 1,
      url: "https://github.com/user/repo1",
      name: "Repo 1",
      description: "This is the first repository",
      primaryLanguage: {
        name: "JavaScript",
        color: "#f1e05a"
      },
      forkCount: 10,
      stargazers: {
        totalCount: 50
      },
      diskUsage: 1024
    }
  },
  {
    node: {
      id: 2,
      url: "https://github.com/user/repo2",
      name: "Repo 2",
      description: "This is the second repository",
      primaryLanguage: {
        name: "Python",
        color: "#3572A5"
      },
      forkCount: 5,
      stargazers: {
        totalCount: 20
      },
      diskUsage: 512
    }
  },
  // Add more dummy repo objects as needed
];


const projectsType =["Web","Mobile",".NET","DApps"]
export default function Projects({projectType,setProjectType}) {
  const GithubRepoCard = lazy(() =>
    import("../../components/githubRepoCard/GithubRepoCard")
  );
  const FailedLoading = () => null;
  const renderLoader = () => <Loading />;
  const [repo, setrepo] = useState([]);
  // todo: remove useContex because is not supported
  const {isDark} = useContext(StyleContext);

  useEffect(() => {
    // const getRepoData = () => {
    //   fetch("/profile.json")
    //     .then(result => {
    //       if (result.ok) {
    //         return result.json();
    //       }
    //       throw result;
    //     })
    //     .then(response => {
    //       setrepoFunction(response.data.user.pinnedItems.edges);
    //     })
    //     .catch(function (error) {
    //       console.error(
    //         `${error} (because of this error, nothing is shown in place of Projects section. Also check if Projects section has been configured)`
    //       );
    //       setrepoFunction("Error");
    //     });
    // };
    // getRepoData();
  }, []);

  function setrepoFunction(array) {
    setrepo(array);
  }
  // if (
  //   !(typeof repo === "string" || repo instanceof String) &&
  //   openSource.display
  // ) {

   
    return (
      <Suspense fallback={renderLoader()}>
        <div className="main" style={{marginTop:"1rem"}} id="opensource">
          {/* <h1 className="project-title">Open Source Projects</h1> */}
       <div className="project-type-div">
          {
            projectsType.map((v,i)=>{
              return <Button key={i} 
              ifOnClick={true}
              text={v} 
              active={projectType==i?true:false}
              className={projectType===i?"project-button":"project-button"} onClick={()=>setProjectType(i)}/>
            })
          }
 </div>


          {/* <div className="repo-cards-div-main">
            {dummyRepoData.map((v, i) => {
              if (!v) {
                console.error(
                  `Github Object for repository number : ${i} is undefined`
                );
              }
              return (
                <GithubRepoCard repo={v} key={v.node.id} isDark={isDark} />
              );
            })}
          </div>
          <Button
            text={"More Projects"}
            className="project-button"
            href={socialMediaLinks.github}
            newTab={true}
          /> */}
        </div>
      </Suspense>
    );
  // } else {
  //   return <FailedLoading />;
  // }
}
